import { TireStatus } from 'app/shared/model/enumerations/tire-status.model';
import { useTheme } from '@mui/material';
import React from 'react';
import { translate } from 'react-jhipster';
import './tire-chassis-structure';

interface ITireData {
  position: number;
  steppe: boolean;
  selected: boolean;
}

interface ITireChassisStructureProps {
  vehicleType: string;
  tireData?: ITireData[];
  typeImplement?: string;
}

export const TireChassisStructure = (props: ITireChassisStructureProps) => {
  const { vehicleType, tireData, typeImplement } = props;

  const theme = useTheme();
  const unselectedOpacity = theme.palette.mode === 'dark' ? 0.3 : 0.5;

  const imagePath = '../../../../content/images/chassis-structure/';
  const chassisImage = `${imagePath}chassis.png`;
  const chassisBackImage = `${imagePath}chassis-back.png`;
  const tireImage = `${imagePath}tire.png`;
  const chassisAxisImage = `${imagePath}chassis-axis.png`;

  const CH = 'CHASSIS'; /* chassis.png */
  const CB = 'CHASSIS_BACK'; /* chassis-back.png */
  const C2 = 'CHASSIS_2_TIRE'; /* chassis-axis.png */
  const C4 = 'CHASSIS_4_TIRE'; /* chassis-axis.png */

  const tireChassisStructureImages = {
    T_1x2: [CH, C2, CB],
    T_1x4: [CH, C4, CB],
    T_2x4: [CH, C2, CH, C2, CB],
    T_4x2: [CH, C2, CH, C4, CB],
    T_3x6: [CH, C2, C2, C2, CB],
    T_2x8: [CH, C4, CH, C4, CB],
    T_4x8: [CH, C2, C2, C2, C2, CB],
    T_6x2: [CH, C2, CH, C4, C4, CB],
    T_8x2: [CH, C2, C2, CH, C4, C4, CB],
    T_3x12: [CH, C4, C4, C4, CB],
    T_4x16: [CH, C4, CH, C4, C4, C4, CB],
    T_6x24: [CH, C4, C4, CH, C4, C4, CH, C4, C4, CB],
  };

  const filterSpireTire = tireData && tireData.length > 0 && tireData.filter(tire => tire.steppe === true).slice(0, 2);

  let tirePosition = 0;

  const renderTire = (isSteppe?: boolean) => {
    const isRotate = isSteppe ? { transform: 'rotate(90deg)' } : undefined;
    const data = tireData?.find(item => item.position === tirePosition + 1);

    tirePosition++;
    return (
      <div className="d-flex">
        <div className="position-relative" style={{ transform: isSteppe ? 'rotate(-90deg)' : undefined }}>
          <img className="rounded" src={tireImage} style={{ opacity: data?.selected ? '' : unselectedOpacity }} />
          <div className={`position-absolute w-100 h-100 rounded`} style={{ backgroundColor: '', top: 0 }}>
            <div className="h-100 d-flex flex-column justify-content-around align-items-center text-white">
              <div
                className="badge badge-light d-flex align-items-center justify-content-center"
                style={{ width: 24, height: 24, padding: 0, ...isRotate }}
              >
                <span className="h6 m-0">{tirePosition}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderChassis = () => {
    const chassis = tireChassisStructureImages[vehicleType];
    if (!chassis) return null;

    return chassis.map((item, i) => (
      <div key={i}>
        <div className="d-flex justify-content-center">
          {item === CH && <img src={chassisImage} />}

          {item === C2 && (
            <div className="d-flex align-items-center">
              {renderTire()}
              <img src={chassisAxisImage} />
              {renderTire()}
            </div>
          )}

          {item === C4 && (
            <div className="d-flex align-items-center">
              <span className="mr-1">{renderTire()}</span>
              {renderTire()}
              <img src={chassisAxisImage} />
              {renderTire()}
              <span className="ml-1">{renderTire()}</span>
            </div>
          )}

          {item === CB && (
            <div className="text-center">
              <img src={chassisBackImage} />
              <div className="mt-1">
                <small>Traseira do {typeImplement ? typeImplement : 'implemento'}</small>
              </div>
            </div>
          )}
        </div>
      </div>
    ));
  };

  const renderIsSteppe = () => {
    return (
      filterSpireTire &&
      filterSpireTire.length > 0 && (
        <div className="position-relative d-flex justify-content-around align-items-center" style={{ height: '75px' }}>
          {filterSpireTire.map((tire, i) => (
            <div key={i} className="d-flex flex-column justify-content-center align-items-center">
              {renderTire(tire.steppe)}
              <div className="position-absolute" style={{ top: '55px' }}>
                <div className="badge">
                  {translate(`fleetSenseApp.TireStatus.${TireStatus.STEPPE}`)} {i + 1}
                </div>
              </div>
            </div>
          ))}
        </div>
      )
    );
  };

  return (
    <>
      {vehicleType && (
        <div id="chassis-structure">
          <div className="text-center mb-1">
            <small>Estrutura</small> <b>{vehicleType.replace('T_', '')}</b>
          </div>
          <div>{renderChassis()}</div>
          <div>{renderIsSteppe()}</div>
        </div>
      )}
    </>
  );
};

export default TireChassisStructure;